__turbopack_context__.v({
  "avatar": "testimonials-module-scss-module__o4ILQa__avatar",
  "card": "testimonials-module-scss-module__o4ILQa__card",
  "header-row": "testimonials-module-scss-module__o4ILQa__header-row",
  "heading": "testimonials-module-scss-module__o4ILQa__heading",
  "slide": "testimonials-module-scss-module__o4ILQa__slide",
  "testimonials": "testimonials-module-scss-module__o4ILQa__testimonials",
  "ud-icon": "testimonials-module-scss-module__o4ILQa__ud-icon",
  "view-all-link": "testimonials-module-scss-module__o4ILQa__view-all-link",
});
